module.exports = "data:image/webp;base64,UklGRh4BAABXRUJQVlA4IBIBAACwDACdASoOAVoAPm02mEmkIqIiIGgAgA2JaW7WjR/3fzf7CGuBL//L6Wsy4AA+h+89ybpJTEdYVnRU5r+Pnm6vI8kQ4U63EOqpNmVN7O1oovEXOwQqf9JS/iWmiiygFWUjxTIekfIngiSUulbIAAD++OUtzB0rdbOTIAgM7AQZVHAirGXYY9xYQZYIbmgwtd70giByAADOVIqNaTHM/AAAADF2B/6VcmkQylWMOpfSTMLG4jd2Khvvc8Y4oVjjZaFAAM4bSrOdPXVGu7ibl0eJE4tkDi1ukqnivYRizqAOlDApdJwFgvWLnc6Q0+acJ8tkXlsg3ZKxDcy7eC+0uCJ5K1z95WOOxbke6tyAYId8QAAA"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/left-bar-bg.webp
// module id = JGty
// module chunks = 3